import { motion } from 'framer-motion';
import { Instagram, Sparkles } from 'lucide-react';
import { Reveal } from '@/components/CloudText';
import { INSTAGRAM_URL } from '@/data/content';
import { scrollToSection } from '@/lib/scroll';

export function ContactSection() {
  return (
    <section id="contact" className="relative px-6 sm:px-[8vw] pt-[10vh] pb-16" data-testid="contact-section">
      <div className="relative max-w-xl">
        <Reveal>
          <motion.div className="glass relative cloud-shape-2 p-10 sm:p-14" animate={{ y: [0, -10, 0] }} transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }} style={{ boxShadow: 'inset 0 0 60px 10px rgba(255,255,255,0.25), 0 30px 80px rgba(3,12,36,0.45)' }}>
            <img src="/assets/logo.png" alt="StorySpark Studios" className="h-16 w-auto -ml-2" />
            <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight mt-4" data-testid="contact-brand">StorySpark Studios</h3>
            <p className="mt-3 font-display text-base text-white/80 leading-snug">Bigger ideas.<br />Bolder designs.<br />Stronger brands.</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="btn-cloud" data-testid="instagram-button"><Instagram size={15} /> @Storysparkstudios_</a>
              <button type="button" onClick={() => scrollToSection('start')} className="btn-cloud primary" data-testid="contact-start-project-button"><Sparkles size={14} /> Start a project</button>
            </div>
          </motion.div>
        </Reveal>
      </div>
      <footer className="mt-24 flex flex-col sm:flex-row sm:items-end justify-between gap-6 border-t border-white/10 pt-8" data-testid="footer">
        <div>
          <p className="font-display text-xs tracking-[0.4em] uppercase text-white/60">StorySpark Studios</p>
          <p className="font-display text-lg sm:text-xl font-semibold mt-2">Bigger ideas. Bolder designs. Stronger brands. 🚀🔥</p>
        </div>
        <p className="text-xs text-white/40">© {new Date().getFullYear()} StorySpark Studios · Sea level is overrated.</p>
      </footer>
    </section>
  );
}
